
















































































import { Component, mixins } from '@niknevis/vue-modules'
import { FilterComponentsMixin } from '@/modules/common/filter/mixins/filterComponentsMixin'
import { datePresetNameMap, DatePresetTypes } from '@/modules/common/filter/filter'
import dayjs from 'dayjs'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';

const dayFormat = 'YYYY/MM/DD'
@Component({
  components: { BaseSelect }
})
export default class DateRange extends mixins(FilterComponentsMixin) {

  $refs!: {
    from: QPopupProxy,
    to: QPopupProxy
  }

  isFromVisible: boolean = false
  isToVisible: boolean = false

  private get hasPreset() {
    return !!this.filter.presets && this.filter.presets.length > 0
  }

  private get presetOptions() {
    if (this.hasPreset) {
      return this.filter
        .presets
        ?.map((preset) => this.generatePresetOption(preset))
    }
    return []
  }

  private selectedPreset: {
    value: DatePresetTypes,
    label: string
  } | null = null

  private get inputsDisabled() {
    return this.selectedPreset?.value !== DatePresetTypes.custom
  }

  private get showSingularInput() {
    return (this.selectedPreset?.value === DatePresetTypes.today || this.selectedPreset?.value === DatePresetTypes.tomorrow || this.selectedPreset?.value === DatePresetTypes.yesterday)
  }

  presetSelect(value: DateRange['selectedPreset']) {
    value && this.generatePresetDates(value.value)
  }

  generatePresetDates(presetType: DatePresetTypes) {
    switch (presetType) {
      case DatePresetTypes.today:
        this.to = dayjs().format(dayFormat)
        this.from = dayjs().format(dayFormat)
        break
      case DatePresetTypes.tomorrow:
        this.to = dayjs().add(1, 'd').format(dayFormat)
        this.from = dayjs().add(1, 'd').format(dayFormat)
        break
      case DatePresetTypes.yesterday:
        this.to = dayjs().subtract(1, 'd').format(dayFormat)
        this.from = dayjs().subtract(1, 'd').format(dayFormat)
        break
      case DatePresetTypes.currentWeek:
        this.from = dayjs().startOf('week').format(dayFormat)
        this.to = dayjs().endOf('week').format(dayFormat)
        break
      case DatePresetTypes.currentMonth:
        this.from = dayjs().startOf('month').format(dayFormat)
        this.to = dayjs().endOf('month').format(dayFormat)
        break
      case DatePresetTypes.lastMonth:
        this.from = dayjs()
          .startOf('month')
          .subtract(1, 'month')
          .format(dayFormat)
        this.to = dayjs()
          .endOf('month')
          .subtract(1, 'month')
          .format(dayFormat)
        break
      case DatePresetTypes.last7Days:
        this.from = dayjs()
          .subtract(7, 'days')
          .format(dayFormat)
        this.to = dayjs().format(dayFormat)
        break
      default:
        break
    }
  }

  generatePresetOption(presetType: DatePresetTypes): DateRange['selectedPreset'] {
    return {
      value: presetType,
      label: datePresetNameMap[presetType]
    }
  }

  checkForSingular(value) {
    if (this.showSingularInput) {
      this.to = value
    }
  }

  protected onReset() {
    this.selectedPreset = null
  }

  mounted() {
    if (this.from && this.to && this.from === this.to) {
      this.selectedPreset = this.generatePresetOption(DatePresetTypes.today)
    } else if (this.from || this.to) {
      this.selectedPreset = this.generatePresetOption(DatePresetTypes.custom)
    }
  }

  protected default = []

  get label() {
    return this.filter.title
  }

  get holder() {
    return this.filter.holder
  }

  get typeMode() {
    return this.filter.typeMode
  }

  public get from() {
    if (!this.filter.keys) return null
    const from = this.service.get(this.filter.keys.from)
    if (!from) return null
    return dayjs(from as any).format(dayFormat)
  }

  public set from(value: any) {
    if (this.isFromVisible) {
      this.$refs.from.hide()
    }
    if (this.filter.keys) {
      let from = dayjs(value, {
        format: dayFormat,
        // @ts-ignore
        jalali: true
      }).calendar('gregory').format(dayFormat)
      if (!value) from = null
      this.service.add(this.filter.keys.from, from)
    }
  }

  public get to() {
    if (!this.filter.keys) return null
    const to = this.service.get(this.filter.keys.to)
    if (!to) return null
    return dayjs(to as any).format(dayFormat)
  }

  public set to(value: any) {
    if (this.isToVisible) {
      this.$refs.to.hide()
    }
    if (this.filter.keys) {
      let to = dayjs(value, {
        format: dayFormat,
        // @ts-ignore
        jalali: true
      }).calendar('gregory').format(dayFormat)
      if (!value) to = null
      this.service.add(this.filter.keys.to, to)
    }
  }

  get defaultTo() {
    return dayjs(this.service.get(this.filter.keys.from) as any).format('YYYY/MM').toString()
  }

  disableFrom(date) {
    return this.to ? date < this.to : true
  }

  disableTo(date) {
    return date >= this.from
  }
}
